<template>
  <div>
    <el-input
      size="medium"
      class="input"
      prefix-icon="el-icon-search"
      :placeholder="placeholder ? placeholder : 'Entrez quelque chose'"
      v-model="input"
      @input="filterResults()"
      data-test="autocomplete-input"
      clearable>
    </el-input>
  </div>
</template>

<script>
  export default {
    props: {
      arrayToFilter: undefined,
      keyToFilter: undefined,
      placeholder: undefined,
    },
    data() {
      return {
        input: '',
      };
    },
    methods: {
      filterResults() {
        this.$emit('bubbleUpInput', this.input);
      },
    },
  };
</script>

<style lang="stylus">
  .input {
    width 100%
  }
</style>
